import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { RouteService } from '../route/route.service';
import { Observable } from 'rxjs';

@Injectable()
export class RouteResolver implements Resolve<boolean> {
  constructor(
    private route: RouteService,
  ) {}

  public resolve = (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> => this.route.routeResolver(next, state);
}

